import { createSelector } from "reselect";

const getAttachmentsFromState = (state: IAppState) => state.attachments;

export const getAttachments = createSelector(
  getAttachmentsFromState,
  attachments => attachments
);
